import React from 'react';

const LinkableTitle = ({ title, name }) => (
  <h3 className="linkable-title" id={name}>
    {/* eslint-disable-next-line */}
    <a className="anchor" aria-hidden="true" href={`#${name}`} />
    {title}
  </h3>
);

export default LinkableTitle;
